import React, { useId } from 'react';
import Module from './Module';
const ModuleWrapper = ({ formData, setFormData, attributes, modules, pll, options = {} }) => {
    let defaultOptions = {
        type: "simple",
        group: null,
    };
    let attrs = Object.assign(Object.assign({}, defaultOptions), options);
    if (attrs.type == "multiple" && attrs.group == null) {
        attrs.group = useId();
    }
    let modulesNode = modules.map((element) => {
        return React.createElement(Module, { pll: pll, options: attrs, element: element, formData: formData, setFormData: setFormData, attributes: attributes });
    });
    if (modules.length < 1) {
        modulesNode = React.createElement(React.Fragment, null, pll("Aucun module disponible pour cette formation."));
    }
    return (React.createElement("section", { className: `module-wrapper ${attrs.type}` },
        React.createElement("div", { className: "header" },
            React.createElement("span", { className: "before-action" }),
            React.createElement("span", { className: "dates" }, pll("Dates")),
            React.createElement("span", { className: "centres" }, pll("Centre(s)")),
            React.createElement("span", { className: "locations" }, pll("Lieux")),
            React.createElement("span", { className: "tickets" }, pll("Places dispos")),
            React.createElement("span", { className: "ref" }, pll("Référence")),
            React.createElement("span", { className: "after-action" })),
        React.createElement("div", { className: "body" }, modulesNode)));
};
export default ModuleWrapper;
